// extracted by css-extract-rspack-plugin
export default {"root":"AMw6e","sidebar":"zLZ_f"};